// extracted by mini-css-extract-plugin
export default {"usersTable":"users-table_usersTable__A-xEF","sortIcons":"users-table_sortIcons__EaeKx","userCategories":"users-table_userCategories__l3OOr"};